import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, Globe2Icon, LockKeyholeIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Button } from './Button';
import { includes, offer } from '../data/offer';
const separatePurchases = ['beginner teaching', 'advanced technique', 'rhythm', 'musicality', 'lesson planning', 'assessment'];
export function PricingSection() {
  return <section id="offer" className="bg-acad-canvas px-4 py-20 sm:py-28" data-id="element-147" data-mp="1na0rxk3yg0ra">
      <div className="mx-auto max-w-3xl" data-id="element-148" data-mp="1s8u5fcj8rrrg">
        <div className="text-center" data-id="element-149" data-mp="1sbq7nd24h2lp">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-150" data-mp="1x86v051hzcxq">
            The complete offer
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-acad-ink sm:text-5xl" data-id="element-151" data-mp="226i60j3j3thj">
            Everything Your Next Tap Dance Class Needs
          </h2>
          <p className="mt-4 text-base leading-7 text-acad-muted" data-id="element-152" data-mp="7ta4k8l1sjmx">
            The complete 6-in-1 professional Tap Dance teaching system.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mt-12 rounded-3xl border border-acad-gold/70 bg-white p-2 shadow-soft" data-id="element-153" data-mp="1mirb8dtfe0y1">
          <div className="absolute -top-4 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full border border-acad-gold/60 bg-acad-goldSoft px-4 py-1.5 text-xs font-bold uppercase tracking-[0.1em] text-acad-ink" data-id="element-154" data-mp="20g64jtmsusva">
            <SparklesIcon size={14} aria-hidden="true" data-id="element-155" data-mp="1ri40143uxi39" /> Complete system
          </div>
          <div className="rounded-[1.25rem] bg-acad-canvas p-6 text-center sm:p-10" data-id="element-156" data-mp="k3ipep9fzwyx">
            <h3 className="font-display text-3xl font-semibold text-acad-ink sm:text-4xl" data-id="element-157" data-mp="fz1bh6prkdw2">
              {offer.name}
            </h3>
            <p className="mt-2 text-acad-muted" data-id="element-158" data-mp="mgundo0fhlgv">{offer.tagline}</p>
            <ul className="mx-auto mt-7 max-w-xl space-y-2.5 rounded-2xl border border-acad-line bg-white p-5 text-left" data-id="element-159" data-mp="mg33vbk3ve6y">
              {includes.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-acad-muted" data-id="element-160" data-mp="chvogx5gt472">
                  <CheckIcon size={17} className="mt-0.5 shrink-0 text-acad-gold" aria-hidden="true" data-id="element-161" data-mp="3uul44r3t1pg0" />
                  {item}
                </li>)}
            </ul>

            <div className="mx-auto mt-8 max-w-xl rounded-2xl border border-acad-line bg-white p-5 text-left" data-id="element-162" data-mp="3pymnjpopxbq5">
              <p className="text-sm leading-6 text-acad-muted" data-id="element-163" data-mp="3bz3d2q8fpoao">
                Instead of buying individual resources for{' '}
                {separatePurchases.join(', ')} — get all six teaching systems
                together.
              </p>
            </div>

            <div className="mt-8" data-id="element-164" data-mp="2scjp0rhvqxme">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-165" data-mp="2sdl2t3qa5y7t">
                <span className="text-xl font-semibold text-acad-ink" data-id="element-166" data-mp="36cug9vn3qe83">
                  TODAY:
                </span>
                <span className="font-display text-4xl font-semibold text-acad-gold sm:text-5xl" data-id="element-167" data-mp="31b57kmncqcn6">
                  {offer.todayPrice}
                </span>
              </div>
            </div>

            <Button href={offer.checkoutUrl} target="_blank" className="mt-7 w-full sm:w-auto" data-id="element-168" data-mp="3bacthy85jflw">
              {offer.ctaOffer}
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-acad-muted" data-id="element-169" data-mp="3l17gx5x4wl8x">
              <span className="flex items-center gap-1.5" data-id="element-170" data-mp="2syks0ezaxa5">
                <LockKeyholeIcon size={14} className="text-acad-gold" aria-hidden="true" data-id="element-171" data-mp="3u2f2cnejxrll" />
                Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-172" data-mp="ly4pten7r6ip">
                <ZapIcon size={14} className="text-acad-gold" aria-hidden="true" data-id="element-173" data-mp="qpw6mxgkhxvn" />
                Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-174" data-mp="3v54g0lwp9k0a">
                <ShieldCheckIcon size={14} className="text-acad-gold" aria-hidden="true" data-id="element-175" data-mp="3v6p53w08waqr" />
                7-day guarantee
              </span>
            </div>

            <p className="mx-auto mt-5 flex max-w-lg items-start gap-2 rounded-xl border border-acad-line bg-white p-3 text-left text-xs leading-5 text-acad-muted" data-id="element-176" data-mp="cziyatzrkh5s">
              <Globe2Icon size={15} className="mt-0.5 shrink-0 text-acad-gold" aria-hidden="true" data-id="element-177" data-mp="1jh66vdqje51g" />
              Pay in your local currency. The final amount automatically adapts
              according to the country and payment method available to you.
            </p>
          </div>
        </motion.div>

        <div className="mt-12 text-center" data-id="element-178" data-mp="2z52vt793vu02">
          <p className="font-display text-2xl font-semibold leading-snug text-acad-ink sm:text-3xl" data-id="element-179" data-mp="2u7au5linstio">
            Plan less. Teach with more structure. Give your students a clearer
            path to progress.
          </p>
        </div>
      </div>
    </section>;
}